import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@services/app-config.service';
import { Observable, shareReplay } from 'rxjs';
import { HubSdkBase } from '@utilities/hub-sdk-base/hub-sdk.base';

@Injectable({
	providedIn: 'root'
})
export class NotificationHubSdk extends HubSdkBase {
	public systemNotifications: string[] = [];

	public systemNotifications$: Observable<string[]> =
		this.on$<string[]>('systemNotifications').pipe(shareReplay(1));

	constructor(
		private http: HttpClient,
		private appConfigService: AppConfigService,
		injector: Injector
	) {
		super(injector, 'notifications');
		this.systemNotifications$.subscribe(sn => this.systemNotifications = sn);
	}

	toggleNotifyWhenCaseCompletesProcessing() {
		const url = `${ this.appConfigService.getConfig().webApi }/api2/notifications`;
		return this.http.post<boolean>(url, {});
	}
}
